import React from 'react';
import {Container} from "react-bootstrap";

function ItemSeparator() {
    return (
        <Container className="searchContainer">
            <div className="gridContainer-separator">
            </div>
        </Container>
    );
}

export default ItemSeparator;